export enum EventsFilter {
	All = "all",
	My = "my",
}
